export default function Footer() {
    return (<footer className="footer">
        <div className="content has-text-centered">
            <p>
                <strong>Wedding Invitation</strong> by <a href="https://berviantoleo.my.id">Bervianto Leo Pratama</a>.
                Made with Love &hearts;.
            </p>
        </div>
    </footer>);
}